export const APP_ROUTES = {
  root: '/',
  login: '/login',
  dashboard: '/',
  trains: {
    root: '/trains',
    detail: (id: string | number) => `/trains/${id}`,
  },
  archive: '/archive',
  chooseRole: '/choose-role',
} as const;
